export enum GroupOwnerType
{
    Individual = 'Individual',
    Corporation = 'Corporation'
}